module.exports = __webpack_public_path__ + "static/media/logo2.988d308b.png";